import { Typography } from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import React, { useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Skeleton from '@material-ui/lab/Skeleton';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import SaveIcon from '@material-ui/icons/Save';
import { useDropzone } from "react-dropzone";
import { connect } from 'react-redux';
import { setIcon } from '../../actions';

const useStyles = makeStyles((theme) => ({
  loader: {
    width: '80%',
    margin: theme.spacing(2),
  },
  container: {
    height: 150,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    padding: theme.spacing(5),
  },
  uploadContainer: {
    height: 150,
    width: 150,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    padding: theme.spacing(2),
    margin: theme.spacing(2),
    border: '1px dashed #000',
    borderRadius: 10,
  }
}));

const ImageUpload = ({
  icon,
  prop,
  title,
  setError, 
  loading,
  save,
  eventId,
  remove,
  ...rest
}) => {
  const classes = useStyles();

  const onDrop = useCallback((acceptedFiles, fileRejections) => {
    if (fileRejections.length > 0) {
      return setError({
        show: true,
        message: "Only PNG files are accepted",
        severity: "error",
      });
    }

    acceptedFiles.forEach((file) => {
      const reader = new FileReader();

      reader.onabort = () => console.log("file reading was aborted");
      reader.onerror = () => console.log("file reading has failed");
      reader.onload = () => {
        const binaryStr = reader.result;
        const i = new Image();

        i.onload = () => {
          if (i.width > 100 || i.height > 100) {
            setError({
              show: true,
              message: "Image exceeds max size of 100x100 px",
              severity: "warning",
            });
          } else {
            rest.setIcon({
              prop,
              icon: binaryStr
            });

            save({
              icon: binaryStr, 
              eventId, 
              name: prop
            });
          }
        };

        i.src = binaryStr;
      };
      reader.readAsDataURL(file);
    });
  }, []);

  const { getRootProps, getInputProps } = useDropzone({ 
    onDrop,
    accept: 'image/png' 
  });

  const renderSaveButtons = () => {
    return (
      <div>
        <IconButton onClick={remove}><HighlightOffIcon color="secondary" /></IconButton>
      </div>
    )
  }

  if (loading) {
    return <div className={classes.loader}>
      <Typography>{title}</Typography>
      <Skeleton variant="rect" width={130} height={130} />
    </div>
  }

  if (icon.length > 0) {
    return <div className={classes.container}>
      <Typography>{title}</Typography>
      <img src={icon} alt="visited" />
      {renderSaveButtons()}
    </div>
  } 

  return (
    <div className={classes.uploadContainer} {...getRootProps()}>
      <>
        <input {...getInputProps()} />
        <Typography>{title}</Typography>
        <CloudUploadIcon fontSize="large" />
      </>
    </div>
  );
};

const mapStateToProps = ({ storage }) => {
  const { loading } = storage;

  return { loading };
}

export default connect(mapStateToProps, { setIcon })(ImageUpload);
